import React, { Component } from "react";

import { CSpinner } from "@coreui/react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { Redirect } from "react-router-dom";
import { bindActionCreators } from "redux";

import {
  login,
  tryLogin,
  externalLogin,
  logout
} from "../../actions/baseActions";
import URL from "../../config/api";
import axios from "../../config/axios";

class ExternalAuth extends Component {
  componentDidMount() {
    const query = new URLSearchParams(window.location.search);
    const { logged } = this.props.general;

    if (logged) {
      this.checkUserAndAuth(query);
    }

    this.authQueries(query);
  }

  isLoggedUser = userId => {
    const loggedUserId = this.props.user.user.id;

    if (loggedUserId && loggedUserId === userId) {
      return true;
    }
    return false;
  };

  checkUserAndAuth = query => {
    const token = query.get("token");

    if (token) {
      // Decodifica o token e verifica o `user_id` dentro dele
      const claims = JSON.parse(atob(token.split(".")[1]));
      const tokenUserId = claims?.sub || claims?.user_id;

      if (this.isLoggedUser(tokenUserId)) {
        // Desloga o usuário atual e inicia o processo de autenticação para o novo usuário
        this.props.logout(token);
        this.authQueries(query); // Reautentica após o logout
      }
    }
  };

  authQueries = async query => {
    const token = query.get("token");

    if (!token) return;

    if (token) {
      try {
        const tokenAuthResponse = await axios.post(`${URL.api}authJwt`, null, {
          headers: { authorization: `Bearer ${token}` }
        });

        // if (
        //   tokenAuthResponse.data.data.user_role[0].role_id === 7 &&
        //   tokenAuthResponse.data.data.user_role[0].group_id === 86
        // ) {
        //   window.location.replace(
        //     `http://avaliacao.educandus.com.br:3000/external_auth?token=${token}`
        //   );
        // }

        this.props.externalLogin(tokenAuthResponse.data.data);
      } catch (error) {
        toastr.error("Falha", "Não foi possível logar");
        this.props.history.push("/");
      }
    }

    const userId = query.get("user_id");

    if (userId) {
      axios.post(`${URL.api}authUserId`, { user_id: userId }).then(
        resp => {
          if (resp.data.success) {
            this.props.externalLogin(resp.data.data);
          } else {
            toastr.error("Falha", "Não foi possível logar");
            this.props.history.push("/");
          }
        },
        error => {
          toastr.error("Falha", "Não foi possível logar");
          this.props.history.push("/");
        }
      );
    }
  };

  render() {
    const { logged } = this.props.general;

    const query = new URLSearchParams(window.location.search);
    const path = query.get("path");
    const token = query.get("token");

    // Get token custom claims
    const claims = token ? JSON.parse(atob(token.split(".")[1])) : {};

    if (logged) {
      if (claims) {
        const tokenUserId = claims?.sub || claims?.user_id;

        if (this.isLoggedUser(tokenUserId)) {
          console.log("Oi");
          return <Redirect to={path || "/"} />;
        }
      }
    }

    return (
      <div
        className="d-flex align-items-center justify-content-center"
        style={{ width: "100vw", height: "100vh" }}
      >
        <CSpinner size="lg" color="primary" className="mr-3" />
        <h3 className="m-0">Entrando na plataforma...</h3>
      </div>
    );
  }
}

ExternalAuth.propTypes = {
  hideLayout: PropTypes.bool,
  guestLogin: PropTypes.bool
};

ExternalAuth.defaultProps = {
  hideLayout: true,
  guestLogin: false
};

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      login,
      tryLogin,
      externalLogin,
      logout
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ExternalAuth);
